export default __webpack_public_path__ + "static/media/supermarket-icon.0fd31f5c.webp";